<template>
  <settings-modal
    :locked="isLoading"
    class="t-subscription-discount-delete-modal"
  >
    <span
      slot="heading"
      class="font-weight-bold"
    >Confirm discount plan deletion</span>

    <error-alert :error="error" />

    <template slot="actions">
      <v-btn
        class="t-confirm-button"
        color="primary"
        medium
        flat
        :disabled="isLoading"
        @click="onConfirmButtonClick"
      >Confirm</v-btn>

      <v-btn
        class="t-cancel-button"
        color="primary"
        medium
        flat
        :disabled="isLoading"
        @click="onCloseButtonClick"
      >cancel</v-btn>
    </template>
  </settings-modal>
</template>

<script>
  import SettingsModal from '@/components/modals/SettingsModal.vue'
  import modal from '@/mixins/modal'
  import { mapActions, mapGetters } from 'vuex'
  import ErrorAlert from '@/components/ui/ErrorAlert.vue'
  import flashMessages from '@/mixins/flashMessages'
  import ApiRequest from '@/services/ApiRequests/ApiRequest'
  import SubscriptionApi from '@/services/Api/Subscription'

  export default {
    name: 'SubscriptionDiscountDeleteModal',
    components: {
      ErrorAlert,
      SettingsModal
    },
    mixins: [modal, flashMessages],
    data () {
      return {
        error: null,
        isLoading: false,
        deleteSubscriptionDiscountApiRequest: new ApiRequest(
          SubscriptionApi.deleteSubscriptionDiscounts
        )
      }
    },
    computed: {
      ...mapGetters('modal', ['modal'])
    },
    methods: {
      ...mapActions('modal', ['showModal', 'closeModal']),
      onConfirmButtonClick () {
        this.setIsLoading(true)
        this.deleteSubscriptionDiscountApiRequest.execute(this.modal.data.id)
          .then(() => this.showSuccessFlashMessage('Subscription discount has been successfully deleted.', {
            onComplete: this.modal.data.successCallback
          }))
          .catch((error) => {
            this.setError(error)
            this.setIsLoading(false)
          })
      },
      onCloseButtonClick () {
        this.closeModal()
      },
      setIsLoading (isLoading) {
        this.$set(this, 'isLoading', isLoading)
      },
      setError (error) {
        this.$set(this, 'error', error)
      }
    }
  }
</script>
